/** Shared by src/app/refunds.tsx and its mirror test (docs/legal/refund-policy.md). */

export const REFUND_POLICY_UPDATED = 'October 24, 2026';
